// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f57f70f8","239":"5f6ea5db","453":"5e0a6c51","667":"b5413512"}[chunkId] + ".chunk.js";
};